import { render, staticRenderFns } from "./OrganismTabsTechnicalSpecsV2.vue?vue&type=template&id=4a70fc30&scoped=true&"
import script from "./OrganismTabsTechnicalSpecsV2.vue?vue&type=script&lang=js&"
export * from "./OrganismTabsTechnicalSpecsV2.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTabsTechnicalSpecsV2.vue?vue&type=style&index=0&id=4a70fc30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70fc30",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsProjectOrganismTechnicalSpecsV2: require('/app/components/organisms/project/OrganismTechnicalSpecsV2.vue').default})
